enum ComponentTypeTransfer {
    AccuracyValidation = 1,
    Lookup = 2,
    Variable = 3,
    IsinSelector = 4,
    LeiSelector = 5,
    ExchangeRatesSelector = 6,
    AnnaDsbUpiEnrichmentSelector = 7,
    AnnaDsbUpiSelector = 8,
    LSESelector = 9,
    Dictionary = 10,
    UserDefinedFunction = 11,
    FirdsFcaInstrumentSelector = 12,
    FirdsEsmaInstrumentSelector = 13,
    FCARegulatedEntitiesSelector = 14,
    Filter = 15,
    DataSource = 16,
    SymbolSelector = 17
}

export default ComponentTypeTransfer;
